import { useEffect, useState } from "react";
import Agent from "../../../Network/Agent";
import { Link } from "react-router-dom";

export default function PowerStatus() {
  const [tenants, setTenants] = useState([]);
  const [acs_alarm, setAcsAlarm] = useState([]);

  const [totals, setTotals] = useState({
    total_sites: 0,
    power_alarms_count: 0,
    dc_low_alarms_count: 0,
    site_down_alarms_count: 0,
    door_alarms_count: 0,
  });

  const fetchPowerStatus = async () => {
    Agent.MANAGEMENT_DASHBOARD.power_status()
      .then((response) => {
        const dataValue = response.data.data;
        // Totals calculation
        const total_sites = dataValue.reduce((sum, t) => sum + t.total_site, 0);
        const power_alarms_count = dataValue.reduce((sum, t) => sum + t.power_alarms_count, 0);
        const dc_low_alarms_count = dataValue.reduce((sum, t) => sum + t.dc_low_alarms_count, 0);
        const site_down_alarms_count = dataValue.reduce((sum, t) => sum + t.site_down_alarms_count, 0);
        const door_alarms_count = dataValue.reduce((sum, t) => sum + t.door_alarms_count, 0);

        setTotals({
          total_sites,
          power_alarms_count,
          dc_low_alarms_count,
          site_down_alarms_count,
          door_alarms_count,
        });

        setTenants(dataValue);

      })
      .catch((error) => {
        console.error("Error fetching power status:", error);
      });
  };

  const getCellStyle = (count) => ({
    fontSize: "12px",
    fontWeight: "800",
    backgroundColor: count > 0 ? "red" : "green",
    color: "white",
  });

  const yellowCellStyle = {
    backgroundColor: "yellow",
    fontWeight: "800",
    color: "black",
  };
  
  const fetchAcsAlarmCount = async ()=>{
    Agent.MANAGEMENT_DASHBOARD.acs_power_status().then((response) => {
      const dataValue = response.data.data;
      setAcsAlarm(dataValue);
      // Process the dataValue as needed for ACS alarms
      console.log("ACS Alarm Data:", dataValue);
    }).catch((error) => {
      console.error("Error fetching ACS power status:", error);
    });
  }

  useEffect(() => {

    fetchPowerStatus();
    fetchAcsAlarmCount();

  }, []);

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h5>Power Status</h5>
        </div>
        <div className="card-body p-0 m-0">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="rms-tab" data-bs-toggle="tab" data-bs-target="#rms-tab-pane" type="button" role="tab" aria-controls="rms-tab-pane" aria-selected="true"><i class="fa-solid fa-list me-2" ></i>RMS Alarm</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="acs-tab" data-bs-toggle="tab" data-bs-target="#acs-tab-pane" type="button" role="tab" aria-controls="acs-tab-pane" aria-selected="false"><i class="fa-solid fa-list me-2" ></i>Access Alarm</button>
            </li>

          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="rms-tab-pane" role="tabpanel" aria-labelledby="rms-tab" tabindex="0">

              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>MNO Name</th>
                    {tenants.map((tenant) => (
                      <th key={tenant.id} style={{ fontSize: "12px" }}>
                        {tenant.name}
                      </th>
                    ))}
                    <th>Total Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Total Sites</th>
                    {tenants.map((t) => (
                      <td key={t.id} style={{ ...yellowCellStyle, backgroundColor: "#a0c6ed" }}>
                        {t.total_site}
                      </td>
                    ))}
                    <td style={yellowCellStyle}>{totals.total_sites}</td>
                  </tr>

                  <tr>
                    <th>Mains Fail</th>
                    {tenants.map((t) => (
                      <td key={t.id} style={getCellStyle(t.power_alarms_count)}>
                        <Link
                          to={`/rms_alarm_filter/1/fatch?tenant_id=${t.id}`}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          {t.power_alarms_count}
                        </Link>
                      </td>
                    ))}
                    <td style={yellowCellStyle}>{totals.power_alarms_count}</td>
                  </tr>

                  <tr>
                    <th>DC Low</th>
                    {tenants.map((t) => (
                      <td key={t.id} style={getCellStyle(t.dc_low_alarms_count)}>
                        <Link
                          to={`/rms_alarm_filter/2/fatch?tenant_id=${t.id}`}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          {t.dc_low_alarms_count}
                        </Link>
                      </td>
                    ))}
                    <td style={yellowCellStyle}>{totals.dc_low_alarms_count}</td>
                  </tr>

                  <tr>
                    <th>Site Down</th>
                    {tenants.map((t) => (
                      <td key={t.id} style={getCellStyle(t.site_down_alarms_count)}>
                        <Link
                          to={`/rms_alarm_filter/26/fatch?tenant_id=${t.id}`}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          {t.site_down_alarms_count}
                        </Link>
                      </td>
                    ))}
                    <td style={yellowCellStyle}>{totals.site_down_alarms_count}</td>
                  </tr>

                  <tr>
                    <th>Door Open</th>
                    {tenants.map((t) => (
                      <td key={t.id} style={getCellStyle(t.door_alarms_count)}>
                        <Link
                          to={`/rms_alarm_filter/12/fatch?tenant_id=${t.id}`}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          {t.door_alarms_count}
                        </Link>
                      </td>
                    ))}
                    <td style={yellowCellStyle}>{totals.door_alarms_count}</td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div class="tab-pane fade" id="acs-tab-pane" role="tabpanel" aria-labelledby="acs-tab" tabindex="0" style={{minHeight: "200px"}}>
              <table className="table table-bordered text-start">
                <thead>
                  <tr>
                    <th>MNO Name</th>
                    <th>Total Count</th>
                  </tr>
                </thead>
                <tbody>

                  {acs_alarm.map((alarm) => (
                   
                    <tr key={alarm.alarm_type}>
                      <th>{alarm?.alarm_master?.name}</th>
                      <td style={getCellStyle(alarm.total_alarms)} className="text-center">
                        <Link
                          to={`/acs_alarm_filter/${alarm.alarm_type}/fatch`}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          {alarm.total_alarms}
                        </Link>
                      </td>
                    </tr>
                  ))}

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}